import { Injectable } from '@angular/core';
import {CrudService} from "../../services";
import {Chargeback, ChargebackStatus, ChargebackToFile} from "../../dto/card";
import { Observable } from 'rxjs';
import { DataListModel } from '../../models/data-list-model';
import {HttpClient, HttpParams, HttpResponse} from "@angular/common/http";
import {BankTransferLoad, LoadTimeline} from "../../dto/bankTransferLoad";
import {GpsLoadResponseFileImportResult} from "../../dto/gps-load-response-file-import-result";
import {Invoice} from "../../dto/invoice";
import {DateTableFilter} from "../../table-datasouces/date-table-filter";
import {PrevNextIdModel} from "../../models/prev-next-id-model";
import {PrevNextModel} from "../../models/prev-next-model";
import {toISODateString} from "../../providers/app-date-adapter";
import {BankTransferLoadTransaction, SelfLoadDeterminationModel} from "../../dto/trustPayTransaction";
import {Sepa} from "../../dto/sepa";
import {Sofort} from "../../dto/sofort";
import {Upload} from "../../dto/upload";
import {IdvUploadDto} from "../../dto/idv-upload";
import {StatementLineDto} from "../../dto/CardbroGateway/statement";

@Injectable({
  providedIn: "root"
})
export class ChargebacksService implements CrudService<Chargeback> {
  readonly apiPath = 'chargebacks/';

  constructor(private http: HttpClient) { }
  get(id: any) {
    return this.http.get(this.apiPath + id) as Observable<Chargeback>;
  }
  getMany(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
    dateFilterCols: string[],
    startFilterDate: Date|null,
    endFilterDate: Date|null,
    someAdditionalData: string) {
    let params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('filterString', filterString)
      .set('sortField', sortField)
      .set( 'sortDirection', sortDirection )
      .set( 'someAdditionalData', someAdditionalData );



    if (dateFilterCols instanceof Array) {
      dateFilterCols.forEach(element => {
        params = params.append('dateFilterCols', element);
      });

      if ( startFilterDate )
        params = params.append('startFilterDate', toISODateString(startFilterDate))
      if ( endFilterDate )
        params = params.append('endFilterDate', toISODateString(endFilterDate))

    }

    return this.http.get(this.apiPath, { params }) as Observable<DataListModel<Chargeback>>;
  }



  add(item: Chargeback): Observable<Object> {
    throw new Error('Method not implemented.');
  }
  update(item: Chargeback) {
    return this.http.put(this.apiPath, item) as Observable<Chargeback>;
  }

  delete(id: any) {
    return this.deleteMany([id]);
  }
  restore(id: any) {
    return this.restoreMany([id]);
  }

  deleteMany(idList: any[]): Observable<Object> {
    let httpParams = new HttpParams();

    idList.forEach(id => {
      httpParams = httpParams.append('list', id.toString());
    });

    return this.http.delete(this.apiPath, { params: httpParams });
  }

  restoreMany(idList: any[]): Observable<Object> {
    let httpParams = new HttpParams();
    idList.forEach(id => {
      httpParams = httpParams.append('list', id.toString());
    });
    return this.http.patch(this.apiPath, null, { params: httpParams });
  }

  getPrev(filters: DateTableFilter, id: number): Observable<number> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}${id}/prev`, { params }) as Observable<number>;
  }

  getNext(filters: DateTableFilter, id: number): Observable<number> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}${id}/next`, { params }) as Observable<number>;
  }

  getPrevNext(filters: DateTableFilter, id: number): Observable<PrevNextModel> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}${id}/prev-next`, { params }) as Observable<PrevNextModel>;
  }





  getFilterParams(filters: DateTableFilter): HttpParams {
    const str =  filters != null ? filters.str || '' : '';
    const dateFilterCols = filters != null ? filters.dateFilterCols || [] : [];
    const startFilterDate = filters != null ? filters.startFilterDate || null : null;
    const endFilterDate = filters != null ? filters.endFilterDate || null : null;
    const someAdditionalData = filters != null ? filters.someAdditionalData || null : null;

    let params = new HttpParams()


      .set('filterString', str)
      .set('startFilterDate', toISODateString(startFilterDate))
      .set('endFilterDate', toISODateString(endFilterDate))
      .set('someAdditionalData', someAdditionalData);

    if (filters != null && filters.sortField) {
      params = params.set('sortField', filters.sortField);
    }
    if (filters != null && filters.sortDirection) {
      params = params.set('sortDirection', filters.sortDirection);
    }

    if (filters != null && filters.enumFilter) {
      params = params.set('enumFilter', filters.enumFilter.value+'_'+filters.enumFilter.key);
    }


    if (dateFilterCols instanceof Array) {
      dateFilterCols.forEach(element => {
        params = params.append('dateFilterCols', element);
      });
    }

    return params;
  }


  getTransactionDetail(id: number) {
    return this.http.get(this.apiPath + id + '/txn-detail') as Observable<StatementLineDto>;
  }

  getFilesList(id: number) {
    return this.http.get(this.apiPath + id + '/files-list') as Observable<ChargebackToFile[]>;
  }

  setStatus(chargebackId: number, newChargebackStatusToSet: ChargebackStatus, reason: string) {
    return this.http.post(this.apiPath + 'save-status',
      {
        chargebackId,
        newStatus: newChargebackStatusToSet,
        reason,
      }, {headers:{'skip-error-snack': 'true'} }) as Observable<Chargeback>;
  }

  getPendingChargebacksCount(): Observable<number> {
    return this.http.get( this.apiPath + 'pending-chargebacks-count', {headers: {'skip-error-snack': 'true'} } ) as Observable<number>;
  }

}
